class ResponseMaker {
    processCategories = (processCategories = {}) => {
        let f = [];
        let Count = 0;
        if (processCategories && Object.entries(processCategories).length > 0) {
            processCategories = this.processFacets(processCategories);
            processCategories.map((v, i) => {
                let here = {
                    value: v.value,
                    Value: v.Value,
                    Name: v.value,
                    count: v.count,
                    Count: v.count,
                    level: v.level
                };
                v.Categories = v.categories;
                if (v.Categories !== undefined && v.Categories !== null && v.Categories !== '' && v.Categories.length) {
                    let inner_res = this.processCategories(v.Categories);
                    here.Categories = inner_res.Categories;
                    here.Count = here.Count + inner_res.count;
                }
                Count = Count + here.Count;
                f.push(here);
            });
        }
        return {
            Categories: f,
            count: Count,
            slug: 'Categories',
            main_label: 'Categories',
            Count: Count
        };
    };

    processFacets = (facets = []) => {
        let f = [];
        if (facets && facets.length > 0) {
            facets.map((v, i) => {
                f[i] = {
                    ...v,
                    value: v.name,
                    count: v.count
                }
            });
        }
        return f;
    };
}

export default ResponseMaker;